/**
 * API Configuration
 * Shared axios instance for all services
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper function to generate CURL command
const generateCurlCommand = (config) => {
  const method = config.method?.toUpperCase() || 'GET';
  const url = `${config.baseURL}${config.url}`;

  let curlCmd = `curl -X ${method} "${url}"`;

  // Add headers
  if (config.headers) {
    Object.entries(config.headers).forEach(([key, value]) => {
      if (value && key.toLowerCase() !== 'content-length') {
        curlCmd += ` \\\n  -H "${key}: ${value}"`;
      }
    });
  }

  // Add data for POST/PUT/PATCH
  if (config.data) {
    const dataStr = typeof config.data === 'string' ? config.data : JSON.stringify(config.data);
    curlCmd += ` \\\n  -d '${dataStr}'`;
  }

  return curlCmd;
};

// Request interceptor to add token and log CURL
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log CURL command
    const curlCmd = generateCurlCommand(config);
    console.log('%c📡 API REQUEST (CURL)', 'color: #0066cc; font-weight: bold; font-size: 12px;');
    console.log(curlCmd);
    console.log('%c---', 'color: #0066cc;');

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors and log responses
api.interceptors.response.use(
  (response) => {
    console.log('%c✅ API RESPONSE', 'color: #00aa00; font-weight: bold; font-size: 12px;');
    console.log(response.data);
    console.log('%c---', 'color: #00aa00;');
    return response;
  },
  (error) => {
    console.log('%c❌ API ERROR', 'color: #cc0000; font-weight: bold; font-size: 12px;');
    console.log(error.response?.data || error.message);
    console.log('%c---', 'color: #cc0000;');

    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
